import { render, staticRenderFns } from "./PricingEditor.vue?vue&type=template&id=5ddac1c0&scoped=true"
import script from "./PricingEditor.vue?vue&type=script&lang=js"
export * from "./PricingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddac1c0",
  null
  
)

export default component.exports